import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchPermissions, getUserGroups, setUserGroups } from '../../actions';
import { Container, Row, Col, Table, Spinner, Alert, InputGroup, Form, Button } from 'react-bootstrap';
import { getCurrentPlatform } from '../../utils/platform';

class PermissionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: '',
      groupPermissions: {} // { groupId: [permission_key, ...] }
    };
  }

  componentDidMount() {
    this.props.fetchPermissions();
    this.props.getUserGroups();
  }

  componentDidUpdate(prevProps) {
    // Khi userGroups thay đổi, khởi tạo groupPermissions từ dữ liệu redux
    if (prevProps.userGroups !== this.props.userGroups) {
      const groupPermissions = {};
      this.props.userGroups.forEach(g => {
        groupPermissions[g._id] = Array.isArray(g.permissions) ? [...g.permissions] : [];
      });
      this.setState({ groupPermissions });
    }
  }

  handleSearch = (e) => {
    this.setState({ keyword: e.target.value });
  };

  handleCheckbox = (groupId, permissionKey) => {
    this.setState(prev => {
      const current = prev.groupPermissions[groupId] || [];
      const checked = current.includes(permissionKey);
      return {
        groupPermissions: {
          ...prev.groupPermissions,
          [groupId]: checked
            ? current.filter(p => p !== permissionKey)
            : [...current, permissionKey]
        }
      };
    });
  };

  handleSelectAll = (groupId, allPermissionKeys) => {
    this.setState(prev => {
      const current = prev.groupPermissions[groupId] || [];
      const isAllSelected = allPermissionKeys.every(key => current.includes(key));
      return {
        groupPermissions: {
          ...prev.groupPermissions,
          [groupId]: isAllSelected ? [] : [...allPermissionKeys]
        }
      };
    });
  };

  handleSave = async () => {
    const { userGroups } = this.props;
    const { groupPermissions } = this.state;
    try {
      // Tạo mảng userGroups mới với permissions cập nhật
      const updatedGroups = userGroups.map(group => ({
        ...group,
        permissions: groupPermissions[group._id] || []
      }));
      await this.props.setUserGroups(updatedGroups);
      this.props.getUserGroups();
      alert('Saved!');
    } catch (err) {
      alert('Save failed!');
    }
  };

  render() {
    const { permissions, userGroups, loading, error, user } = this.props;
    const { keyword, groupPermissions } = this.state;
    
    const filtered = permissions.filter(
      p => p && (p.permission_key || '').toLowerCase().includes(keyword.toLowerCase())
    );
    const allPermissionKeys = filtered.map(p => p.permission_key);

    return (
      <Container fluid>
        <h2 className="text-center">Permission List</h2>
        <Row className="mb-3">
          <Col md={6}>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Search permission..."
                value={keyword}
                onChange={this.handleSearch}
              />
            </InputGroup>
          </Col>
          <Col md={6} className="text-end">
            <Button variant="success" onClick={this.handleSave}>Save</Button>
          </Col>
        </Row>
        {loading && (
          <div className="text-center mb-3">
            <Spinner animation="border" variant="primary" />
            <span className="ms-2">Loading permissions...</span>
          </div>
        )}
        {error && <Alert variant="danger">{error.message || 'Error loading permissions'}</Alert>}
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th className="text-center align-middle">#</th>
              <th className="text-center align-middle">PERMISSION_KEY (API)</th>
              {userGroups.map(g => (
                <th className="text-center align-middle" key={g._id}>{g.name || g.group_name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td className="text-center align-middle">Select All</td>
              {userGroups.map(g => {
                const current = groupPermissions[g._id] || [];
                const isAllSelected = filtered.length > 0 && filtered.every(p => current.includes(p.permission_key));
                return (
                  <td className="text-center align-middle" key={g._id + '-selectall-row'}>
                    <Form.Check
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={() => this.handleSelectAll(g._id, filtered.map(p => p.permission_key))}
                      style={{ margin: 0 }}
                    />
                  </td>
                );
              })}
            </tr>
            {filtered.map((p, idx) => (
              <tr key={p.permission_key || idx}>
                <td className="text-center align-middle">{idx + 1}</td>
                <td className="align-middle">{p.permission_key}</td>
                {userGroups.map(g => (
                  <td className="text-center align-middle" key={g._id}>
                    <Form.Check
                      type="checkbox"
                      checked={
                        groupPermissions[g._id] && groupPermissions[g._id].includes(p.permission_key)
                      }
                      onChange={() => this.handleCheckbox(g._id, p.permission_key)}
                      style={{ margin: 0 }}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.permissionsReducer.permissions || [],
  userGroups: state.userGroupsReducer.userGroups || [],
  loading: state.permissionsReducer.loading,
  error: state.permissionsReducer.error,
  user: state.authenReducer.user
});

export default connect(mapStateToProps, { fetchPermissions, getUserGroups, setUserGroups })(PermissionList); 